function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.99972 3.31852L12.682 7.00098L4.68606 14.9973L1.403 15.3597C0.963496 15.4083 0.59216 15.0367 0.641058 14.5972L1.00635 11.3117L8.99972 3.31852ZM14.9595 2.77027L13.2305 1.04122C12.6912 0.501884 11.8165 0.501884 11.2772 1.04122L9.65063 2.66786L13.3329 6.35032L14.9595 4.72368C15.4988 4.18405 15.4988 3.3096 14.9595 2.77027Z",
  fill: "#9D9D9D"
});

const SvgPencil = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil.97c14272.svg";
export { ForwardRef as ReactComponent };